import { useEffect, useState } from "react";
import ServiceMainComponent from "./components/layout";
import { servicesData } from "../../data/servicesData";
import { ServiceData } from "../../components/interfaces";
import { SEO } from "../../components/SEO";

export default function Service2() {
  const serviceName = "Chiropractic Care";
  const [otherServicesData, setOtherServicesData] = useState<ServiceData[]>([]);
  const [selectedService, setSelectedService] = useState<ServiceData>();

  useEffect(() => {
    const data = servicesData.filter(
      (service) => service.title !== serviceName
    );
    const servicePage = servicesData.find(
      (service) => service.title === serviceName
    );
    setSelectedService(servicePage);
    setOtherServicesData(data);
  }, []);
  return (
    <>
      <SEO 
        title="Book Chiropractic Therapy in Canada | Last Minute Wellness"
        description="Find chiropractic therapy in Canada with verified experts. Book instantly and restore your mobility with Last Minute Wellness."
        url="https://lastminutewellness.ca/service/chiropractic"
        image="https://lastminutewellness.ca/about-banner.png"
      />
      <ServiceMainComponent
        serviceTitle={serviceName}
        serviceImage={selectedService?.image}
        serviceDescData={selectedService?.desc}
        otherServicesData={otherServicesData}
      />
    </>
  );
}
